module.exports = __webpack_public_path__ + "img/logo-en.8e296670.jpg";